module.exports = __webpack_public_path__ + "static/projektowanie-opakowan-material-4988d3b6ebc753d23fa75ce2b6ff3a0f.jpg";